"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("@fluentui/react");
var react_i18next_1 = require("react-i18next");
var forms_1 = require("../../forms");
require("./Styles/error-popup.scss");
exports.ErrorPopup = function (props) {
    var errorMessage = props.errorMessage, onGoBackHome = props.onGoBackHome, onReportError = props.onReportError, backgroundPicture = props.backgroundPicture, onClose = props.onClose, visible = props.visible;
    var t = react_i18next_1.useTranslation(['ErrorReporting']).t;
    return (react_1.default.createElement(forms_1.Dialog, { hidden: !visible, onDismiss: function () {
            onClose();
        }, maxWidth: 464, title: t('Popup.Title') },
        react_1.default.createElement("div", { className: 'eta-popup-content' },
            react_1.default.createElement("div", { className: 'eta-img' },
                react_1.default.createElement("img", { src: backgroundPicture, alt: 'Error' })),
            react_1.default.createElement("div", { className: 'eta-error-title' }, t('Popup.AppError')),
            react_1.default.createElement("div", { className: 'eta-error-description' }, t('Popup.AppErrorSub')),
            react_1.default.createElement("div", { className: 'eta-error-description' }, errorMessage),
            react_1.default.createElement("div", { className: 'eta-btns' },
                react_1.default.createElement(react_2.DefaultButton, { text: t('Popup.Home'), iconProps: { iconName: 'Home' }, onClick: onGoBackHome }),
                react_1.default.createElement(react_2.PrimaryButton, { text: t('Popup.Report'), onClick: onReportError })))));
};
//# sourceMappingURL=ErrorPopup.js.map